import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import * as moment from "moment";
import {BsModalService, ModalDirective} from "ngx-bootstrap";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {EventsService} from "../../../../services/events/events.service";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'tripmakery-request-follow-up-add-modal',
  templateUrl: './modal-request-follow-up-add.component.html',
  styleUrls: ['./modal-request-follow-up-add.component.css']
})
export class ModalRequestFollowUpAddComponent implements OnInit {
  @Input() housingId: string;
  public form: FormGroup;

  @ViewChild('childModal') public childModal: ModalDirective;


  constructor(private http: HttpClient,
              private eventsService: EventsService) {
    this.form = new FormGroup({
      'requestId': new FormControl({value: '', disabled: false}),
      'followUpAt': new FormControl({value: '', disabled: false}),
    })
  }


  ngOnInit() {
    this.eventsService.on('requestShowModalRequestFollowUpAdd', (requestId: string, date: Date) => {
      if (requestId != null) {
        this.form.patchValue({'requestId': requestId})
      } else {
        this.form.patchValue({'requestId': ''})
      }

      if (date != null) {
        this.form.patchValue({'followUpAt': date})
      } else {
        this.form.patchValue({'followUpAt': ''})
      }

      this.showChildModal()
    });
  }

  public showChildModal(): void {
    this.childModal.show();
  }

  public hideChildModal(): void {
    this.childModal.hide();
  }

  public handleClick() {
    this.http.patch(environment.urls.service + '/api/v1/authenticated/admin/request/' + this.form.get('requestId').value + '/follow-up', {
      followUpAt: this.createNullIfEmptyString(this.form.get('followUpAt').value),
    })
      .subscribe(
        (response: any) => {
          this.eventsService.broadcast('refreshRequestFollowUpList');
        },
        (error) => {

        },
        () => {
          this.hideChildModal();
        }
      );
  }

  private createNullIfEmptyString(s: string) {
    if (s != null && typeof s === "string" && s.trim() === '') {
      return null;
    }
    return s;
  }

  private createFalseIfEmptyString(s: string) {
    if (s != null && typeof s === "string" && s.trim() === '') {
      return false;
    }
    return s;
  }

}
